import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik } from "formik";
import Cookies from "universal-cookie";
import { jwtDecode } from "jwt-decode";
import { LessonSchema } from "../../Validations/LessonSchema";
import { getUnconfirmedComments } from "../../api/Comments";
import Navigation from "../Navigation";
import CommentsTable from "../tables/CommentsTable";

import Header from "../Header";
import ReplyForm from "../Forms/replyForm";
import NotFoundPage from "./404";

const Comments = () => {
  const [Error, setError] = useState("");

  const [phoneNum, setphoneNum] = useState();
  const [decoded, setdecoded] = useState({ phone: "" });

  const [data, setData] = useState([]);

  const [newData, setNewData] = useState([]);
  const [nPages, setNPages] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);

  const [recordsPerPage] = useState(5);

  const [isReplyFormOpen, setIsReplyFormOpen] = useState(false);
  const [selectedCommentId, setSelectedCommentId] = useState(null);

  const formData = new FormData();
  const cookies = new Cookies();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getUnconfirmedComments();
        setData(res.data.response);
      } catch (e) {
        console.log(e);
      }
    };
    fetchData();
    const token = cookies.get("jwt-auth");
    setphoneNum(cookies.get("phoneNum"));
    if (token) {
      setdecoded(jwtDecode(token));
    }
  }, []);

  useEffect(() => {
    if (data) {
      const lastQuestion = currentPage * recordsPerPage;
      const firstQuestion = lastQuestion - recordsPerPage;
      setNewData(data.slice(firstQuestion, lastQuestion));
      setNPages(Math.ceil(data.length / recordsPerPage));
    }
  }, [data, currentPage]);

  const handleReplyClick = (commentId) => {
    setSelectedCommentId(commentId);
    setIsReplyFormOpen(true);
  };

  return <NotFoundPage />;

  return (
    <>
      <div className="w-full flex justify-center flex-col items-center">
        <Header />
        <div className="flex flex-col md:flex-row gap-6 justify-between w-full">
          <Navigation />
          <CommentsTable data={newData} onReplyClick={handleReplyClick} />
        </div>
        <ReplyForm
          isOpen={isReplyFormOpen}
          onClose={() => setIsReplyFormOpen(false)}
          commentId={selectedCommentId}
        />
      </div>
    </>
  );
};

export default Comments;
